import type { Action } from './actions'
import type { CouponsCategory } from 'shared/types/api'
import type { MarketingAnimationLight } from 'shared/types'

export type State = {
    couponsCategories: Array<CouponsCategory>,
    marketingAnimation: MarketingAnimationLight,
    dealsError?: any,
    dealsNetworkError?: any
}

const initialState: State = {
    couponsCategories: [],
    marketingAnimation: {
        imageUrl: '',
        actionUrl: '',
        appRoute: '',
        external: false
    }
}

export const reducer = (state: State = initialState, action: Action): State => {
    switch (action.type) {
        case 'PAGE_DATA_DEALS_RESPONSE':
            return {
                ...state,
                couponsCategories: action.dealsPage.couponsCategories,
                marketingAnimation: action.dealsPage.marketingAnimationLight,
                dealsError: undefined
            }
        case 'PAGE_API_ERROR':
            return {
                ...state,
                dealsError: action.error
            }
        case 'RESET_NETWORK_ERROR':
            return {
                ...state,
                dealsNetworkError: undefined
            }
        case 'PAGE_NETWORK_ERROR':
            return {
                ...state,
                dealsNetworkError: action.networkError,
                dealsError: undefined
            }
        default:
            return state
    }
}
